import React, { useEffect, useState } from "react";
import { Card, Col, Tabs, Tab, Spinner } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import {
  pilferageColumnConfig,
  stockColumnConfig,
  trendSplineConfig,
} from "../Highcharts/chartconfig";
import ChartComponent from "../Highcharts/ChartComponent";
import "./opendashboard.css";
import "./variable.css";
import TopIndicators from "./TopIndicators";
import ClassificationCases from "./ClassificationCases";
import TrendCases from "./TrendCases";
import CountiesCases from "./CountiesCases";
import AllReportedCountryCases from "./AllReportedCountryCases";
import ThematicCases from "./ThematicCases";
import UserReportedCases from "./UserReportedCases";
import HumanRightes from "./HumanRightes";
import HumanRightsIssues from "./HumanRightsIssues";
import HumanRightsIssuseDis from "./HumanRightsIssuseDis";
import HumanRightsIssuesRepro from "./HumanRightsIssuesRepro";
import HumanRightsIssusesNeglect from "./HumanRightsIssusesNeglect";
import Commodities from "./Commodities";
import ConsumablesStock from "./ConsumablesStock";
import "react-datetime/css/react-datetime.css";
import { connect } from "react-redux";
import imgurl from "../assets/images/imgurl";
import axios from "axios";
import Loader from "./Loader";
import Filters from "../Components/Filters/Filters";

const mapStateToProps = (state) => ({
  globalFilter: state.globalFilter,
  serviceIndicators: state.serviceIndicator,
  activeServiceId: state.activeService,
});

const COLORS_ARR = [
  "#38a889",
  "#ed7d32",
  "#7f7f7f",
  "#ffbf00",
  "#99cc33",
  "#339900",
  "#ffcc00",
  "#ff9966",
  "#cc3300",
  "#562F1E",
  "#AF7F24",
  "#263249",
  "#5F7F90",
  "#D9CDB6",
];

function OpenDashboard({ globalFilter, serviceIndicators, activeServiceId }) {
  const [serviceCount, setServiceCount] = useState([]);
  const [quarterLists, setQuarterLists] = useState([]);
  const [resolvedCasesResponse, setResolvedCasesResponse] = useState([]);
  const [trendChartResponse, setTrendChartResponse] = useState([]);
  const [humanRightsReponse, setHumanRightsReponse] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (activeServiceId !== 1) {
      individualService(activeServiceId);
    }
  }, [activeServiceId]);

  const sequence = [
    "Commodities",
    "Treatment literacy",
    "Human Rights",
    "Support Groups",
    "Service delivery",
  ];

  const filteredServiceIndicators = serviceIndicators.sort((a, b) => {
    const indexA = sequence.indexOf(a.serviceName);
    const indexB = sequence.indexOf(b.serviceName);

    return indexA - indexB;
  });

  const iconMapping = {
    0: imgurl.serviceIndicatorIcon1,
    1: imgurl.serviceIndicatorIcon2,
    2: imgurl.serviceIndicatorIcon3,
    3: imgurl.serviceIndicatorIcon4,
    4: imgurl.serviceIndicatorIcon5,
  };

  const getIcon = (val) => {
    return iconMapping[val] || imgurl.serviceIndicatorIcon1;
  };

  const CalculateDepndantData = (p_arr, p_data) => {
    p_data.forEach((e) => {
      p_arr.push({ ...e });
      let { dependentQuestionResponse } = e;
      if (
        Array.isArray(dependentQuestionResponse) &&
        dependentQuestionResponse.length > 0
      ) {
        CalculateDepndantData(p_arr, dependentQuestionResponse);
      }
    });
  };

  const individualService = async (serviceId) => {
    const data = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      serviceId,
      caseStatusFilter: ["Open", "Resolved"],
      languageId: 1,
    };
    const resolvedCasesPayload = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      identifier: "resolvedCommoditiesCases",
      serviceId,
      languageId: 1,
    };
    const trendChartPayload = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      serviceId,
      languageId: 1,
    };
    const humRightsPayload = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      serviceId,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/casesReportedUnderHumanRights`,
        humRightsPayload
      )
      .then(({ data }) => {
        const serviceNames = data?.data && Object.keys(data?.data);

        const calculatePercentage = (yAxis) => {
          const totalCount = yAxis.reduce((current, accumlator) => {
            return current + accumlator;
          });

          return yAxis.map((y) => {
            let percentage = Math.round((y / totalCount) * 100);
            return {
              percent: percentage,
              y,
            };
          });
        };

        const humanRightsInfo = serviceNames?.map((serviceName) => {
          const serviceWiseInfo = data.data[serviceName];
          const xAxis = Object.keys(serviceWiseInfo);
          const yAxis = Object.values(serviceWiseInfo);
          const percent = calculatePercentage(yAxis);
          return {
            name: serviceName,
            percent,
            xAxis,
          };
        });
        setHumanRightsReponse(humanRightsInfo);
      })
      .catch((error) => {
        console.log("casesReportedUnderHumanRights", error);
      });
    setLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/casesCountBasedOnStatus`,
        data
      )
      .then(({ data }) => {
        let responses = data.data;

        const openCount = [];
        const quarter = [];
        const resolvedCount = [];
        const totalCount = [];
        if (responses) {
          responses.forEach((response, index) => {
            openCount.push(response.openCount);
            quarter.push(response.quarter);
            resolvedCount.push(response.resolvedCount);
            totalCount.push(response.totalCount);
          });
          setQuarterLists(quarter);
          setServiceCount([
            {
              name: "Open Count",
              data: openCount.reverse(),
              color: "#38a889",
            },
            {
              name: "Resolved Count",
              data: resolvedCount.reverse(),
              color: "#ed7d32",
            },
            {
              name: "Total Count",
              data: totalCount.reverse(),
              color: "#7f7f7f",
            },
          ]);
        } else {
          setQuarterLists([]);
          setServiceCount([]);
        }
      })
      .catch((error) => {
        console.log("casesCountBasedOnStatus", error);
      });
    axios
      .post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/casesCountForOpenDashboard`,
        resolvedCasesPayload
      )
      .then(({ data }) => {
        setResolvedCasesResponse(data.data);
      })
      .catch((error) => {
        console.log("casesCountForOpenDashboard", error);
      });
    axios
      .post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/casesCountForOpenDashboard`,
        trendChartPayload
      )
      .then(({ data }) => {
        setTrendChartResponse(data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("casesCountForOpenDashboard", error);
        setLoading(false);
      });
  };

  const chartOptions = (quarterList, servicesCount) => {
    const chart1 = {
      title: {
        text: "",
        align: "left",
        style: {
          color: "black",
          align: "left",
          textAlign: "left",
        },
      },

      chart: {
        type: "spline",
      },

      subtitle: {
        text: "",
      },

      yAxis: {
        title: {
          text: "",
        },
      },

      xAxis: {
        categories: quarterList.reverse(),
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },

      plotOptions: {
        series: {
          label: {
            connectorAllowed: false,
          },
        },
      },

      series: servicesCount.slice(0, 3),
      responsive: {
        rules: [
          {
            condition: {
              // maxWidth: 500,
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
              },
            },
          },
        ],
      },
    };
    return chart1;
  };

  const calculatePercentage = (yAxis) => {
    const totalCount = yAxis.reduce((current, accumlator) => {
      return current + accumlator;
    });

    return yAxis.map((y) => {
      let percentage = Math.round((y / totalCount) * 100);
      return {
        percent: percentage,
        y,
      };
    });
  };

  return (
    <>
      <Filters />
      {loading ? (
        <div className="service-indicator-loader">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        filteredServiceIndicators.map(
          (filteredServiceIndicator) =>
            activeServiceId == filteredServiceIndicator.serviceId && (
              <div className="service-charts-container">
                {quarterLists.length > 0 && (
                  <div className="openDashboard-section col-6">
                    <div className="chart-section service-charts">
                      <Card className="">
                        <Card.Body className="pb-3">
                          <h5>Trend of commodities case status</h5>
                          {quarterLists.length > 0 ? (
                            <ChartComponent
                              options={chartOptions(quarterLists, serviceCount)}
                            />
                          ) : (
                            <Loader />
                          )}
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                )}
                {trendChartResponse.map((trendChart) => {
                  if (trendChart.chartType === "barChart") {
                    const xAxis = Object.keys(
                      trendChart.optionCounts
                    ).reverse();
                    const yAxis = Object.values(
                      trendChart.optionCounts
                    ).reverse();
                    const percentValues = calculatePercentage(yAxis);
                    const barCharts = {
                      catagoriesArr: xAxis,
                      percentValues,
                    };

                    return (
                      Object.keys(barCharts).length > 0 && (
                        <div className="openDashboard-section col-6">
                          <div className="chart-section service-charts">
                            <Card>
                              <Card.Body className="pb-3">
                                <h5>{trendChart.name}</h5>
                                <ChartComponent
                                  options={stockColumnConfig(barCharts)}
                                />
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      )
                    );
                  } else {
                    const catagoriesArr = Object.keys(
                      trendChart.optionCounts
                    ).reverse();
                    const chartValues = Object.values(
                      trendChart.optionCounts
                    ).reverse();
                    const trendCharts = { catagoriesArr, chartValues };
                    return (
                      <div className="openDashboard-section col-6">
                        <div className="chart-section service-charts">
                          <Card>
                            <Card.Body className="pb-3">
                              <h5>{trendChart.name}</h5>
                              {trendChartResponse.length > 0 ? (
                                <ChartComponent
                                  options={trendSplineConfig(trendCharts)}
                                />
                              ) : (
                                <Loader />
                              )}
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    );
                  }
                })}
                {resolvedCasesResponse.map((resolvedCase) => {
                  const catagoriesArr = Object.keys(
                    resolvedCase.optionCounts
                  ).reverse();
                  const chartValues = Object.values(
                    resolvedCase.optionCounts
                  ).reverse();
                  const trendCharts = { catagoriesArr, chartValues };
                  return (
                    <div className="openDashboard-section col-6">
                      <div className="chart-section service-charts">
                        <Card>
                          <Card.Body className="pb-3">
                            <h5>{resolvedCase.name}</h5>
                            {Object.keys(resolvedCase).length > 0 ? (
                              <ChartComponent
                                options={trendSplineConfig(trendCharts)}
                              />
                            ) : (
                              <Loader />
                            )}
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  );
                })}
                {humanRightsReponse &&
                  humanRightsReponse.map((humanRight) => {
                    return (
                      <div className="openDashboard-section col-6">
                        <div className="chart-section service-charts">
                          <Card>
                            <Card.Body className="pb-3">
                              <h5>{humanRight.name}</h5>
                              <ChartComponent
                                options={stockColumnConfig({
                                  percentValues: humanRight.percent,
                                  catagoriesArr: humanRight.xAxis,
                                })}
                              />
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    );
                  })}
                {quarterLists.length <= 0 &&
                  trendChartResponse.length <= 0 &&
                  resolvedCasesResponse.length <= 0 && (
                    <div className="data-not-available">Data Not Available</div>
                  )}
              </div>
            )
        )
      )}
      {activeServiceId == 1 && (
        <div className="openDashboard-section">
          <div className="p-20px">
            {/*Sidebar section  */}

            {/* Indicators section start */}

            <TopIndicators requestData={globalFilter} />

            {/* Indicators section end */}

            {/*Main Section  */}
            {/* <Link to="/serviceIndicator">Service Indicator</Link> */}

            <div className="chart-section">
              {/* reported cases column charts 1st section */}
              <Row className="reporting-cases-row">
                <Col lg={4} className="reporting-cases">
                  {/* <Card.Header>Trend of cases reported over time</Card.Header> */}
                  <TrendCases requestData={globalFilter} />
                </Col>
                <Col lg={4} className="reporting-cases">
                  {/* <Card.Header>Classification of cases reported</Card.Header> */}
                  <ClassificationCases requestData={globalFilter} />
                </Col>
                <Col lg={4} className="reporting-cases">
                  {/* <Card.Header>Top 10 Counties reporting cases</Card.Header> */}
                  <CountiesCases requestData={globalFilter} />
                </Col>
              </Row>

              {/* thematic cases pie charts 2nd section */}
              <Row className="pie-chart">
                <Col lg={12}>
                  <ThematicCases requestData={globalFilter} />
                </Col>
              </Row>

              {/* column charts 3rd section */}
              <Row className="summary-section">
                <Col lg={6} className="summary-section-column">
                  {/* <Card.Header>Summary of cases reported under commodities</Card.Header> */}
                  <Commodities requestData={globalFilter} />
                </Col>
                <Col
                  lg={4}
                  className="summary-section-column"
                  style={{ display: "none" }}
                >
                  <Card>
                    {/* <Card.Header>Top 10 Pilferage/Theft Cases Reported</Card.Header> */}
                    <Card.Body className="pb-3">
                      <h5>Top 10 Pilferage/Theft Cases Reported</h5>
                      <ChartComponent options={pilferageColumnConfig()} />
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={6} className="summary-section-column">
                  {/* <Card.Header>Top 10 Consumables reported as out of stock</Card.Header> */}
                  <ConsumablesStock requestData={globalFilter} />
                </Col>
              </Row>

              {/* Human Rights donut pie charts 4th section */}
              <Row className="pie-chart pie-donutchart">
                <Col lg={12}>
                  <Card className="pie-card">
                    <Card.Header className="pie-heading">
                      Distribution of human rights related
                    </Card.Header>
                    <Card.Body>
                      {/* <h5> Status of the cases reported by thematic areas</h5>                   */}
                      <Row className="">
                        <Col lg={12}>
                          <HumanRightes requestData={globalFilter} />
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* 5th column charts section  */}
              <Row className="sectionfivecard">
                <Col lg={6}>
                  <Card>
                    {/* <Card.Header>Trend of cases reported over time</Card.Header> */}
                    <Card.Body className="pb-3">
                      <h5>Distribution of GBV related cases</h5>
                      <HumanRightsIssues requestData={globalFilter} />
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={6}>
                  <Card>
                    {/* <Card.Header>Classification of cases reported</Card.Header> */}
                    <Card.Body className="pb-3">
                      <h5>
                        Distribution of discrimination/stigma related cases
                      </h5>
                      <HumanRightsIssuseDis requestData={globalFilter} />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* 6th column charts section  */}
              <Row className="sectionsixcard">
                <Col lg={6}>
                  <Card>
                    {/* <Card.Header>Top 10 Counties reporting cases</Card.Header> */}
                    <Card.Body className="pb-3">
                      <h5>
                        Distribution of sexual reproductive health related cases
                      </h5>
                      <HumanRightsIssuesRepro requestData={globalFilter} />
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={6}>
                  <Card>
                    {/* <Card.Header>Top 10 Counties reporting cases</Card.Header> */}
                    <Card.Body className="pb-3">
                      <h5>Distribution of neglected related cases</h5>
                      <HumanRightsIssusesNeglect requestData={globalFilter} />
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* 7th column charts section  */}
              <Row className="sectionsevencard">
                {/* <Card.Header>Top 10 Counties reporting cases</Card.Header> */}

                <Col lg={12} style={{ marginBottom: "1.5rem" }}>
                  <AllReportedCountryCases requestData={globalFilter} />
                </Col>
                <Col lg={12}>
                  {/* <Card.Header>Top 10 Counties reporting cases</Card.Header> */}
                  <UserReportedCases requestData={globalFilter} />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default connect(mapStateToProps)(OpenDashboard);
